<div
    [style.display]="selected ? '' : 'none'"
    role="tabpanel"
    [id]="id + '.panel'"
    [attr.aria-labelledby]="id"
    [agprLoading]="loading"
>
    <ng-template #tabHeader>
        @if (!hideBusinessCard) {
            <agpr-entity-business-card
                [id]="id + '_staffTabBusinessCard'"
                [isRHP]="true"
                [canOpenFullProfile]="false"
                [entity]="selectedOutlet"
                [contactPrivateData]="contactPrivateData"
                [outletPrivateData]="outletPrivateData"
                [isCondensedMode]="true"
            ></agpr-entity-business-card>
        }
        <!-- top row -->
        <div
            class="agpr-staffSearch-filterWrapper"
            [@toolbarCollapsed]="toolbarStateService.toolbarCollapsed && !toolbarStateService.toolbarAnimationDisabled"
            (@toolbarCollapsed.start)="onAnimationStart($event)"
            (@toolbarCollapsed.done)="onAnimationDone($event)"
        >
            <div
                class="agpr-staffSearch-filterToolbar"
                [ngClass]="{'agpr-staffSearch-filterToolbar--chips': chipsVisible}"
            >
                <div class="agpr-staffSearch-filterToolbar-filterInput">
                    <agpr-filter-dropdown
                        [id]="id + 'resultsFilters'"
                        [showQuickFilter]="true"
                        quickFilterPlaceholder="Discover.targeting.filter.quick.contactName.placeholder"
                        [ariaLabel]="'Discover.targeting.rhp.tabs.staff.filterLabel' | localize"
                        [ariaDescribedBy]="id + 'filter.chips'"
                    ></agpr-filter-dropdown>
                </div>
                <agpr-sort-order
                    [id]="id + '_staffSearch-sortOrder'"
                    class="agpr-staffSearch-filterToolbar-sortOrder"
                    [isDisabled]="!total"
                    tooltip="Discover.targeting.tooltips.sort"
                    optionKey="enumValue"
                    optionLabel="displayString"
                ></agpr-sort-order>
            </div>
            @if (chipsVisible) {
                <agpr-filter-chips
                    [id]="id + 'filter.chips'"
                    class="agpr-staffSearch-filterChips"
                ></agpr-filter-chips>
            }
        </div>

        <!-- second row -->
        <div
            class="agpr-targetingResults-listBuilder-rhp"
            [@toolbarCollapsed]="toolbarStateService.toolbarCollapsed && !toolbarStateService.toolbarAnimationDisabled"
            (@toolbarCollapsed.start)="onAnimationStart($event)"
            (@toolbarCollapsed.done)="onAnimationDone($event)"
        >
            <!-- Use <form novalidate> to remove the extra validate message in Staff search tab -->
            <form class="agpr-targetingResults-listBuilder-formValidate" novalidate>
                <agpr-autocomplete
                    #listBuilderDropdown
                    [id]="id + '.listBuilderDropdown'"
                    labelField="name"
                    placeholder="Discover.listBuilder.widget.placeholder.dropdown"
                    [dropdown]="true"
                    dropdownMode="current"
                    [(ngModel)]="selectedLists"
                    [customOptions]="listBuilderOptions"
                    (itemSelected)="updateListBuilder()"
                    [suggestions]="targetingLists$"
                    [multiSelection]="true"
                    [pTooltip]="'Discover.listBuilder.widget.tooltip.dropdown' | localize"
                    tooltipPosition="top"
                    ariaLabel="Discover.listBuilder.widget.placeholder.dropdown"
                    [showHiddenOption]="true"
                ></agpr-autocomplete>
            </form>
            <span class="agpr-targetingResults-listBuilder-lock">
                <agpr-button
                    [ngClass]="{
                        'agpr-targetingResults-toolbarIcon--lock': workingListsLocked,
                        'agpr-targetingResults-toolbarIcon--unlock': !workingListsLocked
                    }"
                    [style]="buttonTypes.icon"
                    [id]="id + '.listBuilder.lock'"
                    (click)="listPickerService.toggleWorkingListsLock()"
                    [icon]="workingListsLocked ? 'fa-regular fa-duotone fa-lock' : 'fa-regular fa-duotone fa-unlock'"
                    [tooltip]="workingListsLocked ? 'Discover.listBuilder.widget.tooltip.unlock' : 'Discover.listBuilder.widget.tooltip.lock'"
                    tooltipPosition="top"
                ></agpr-button>
            </span>
            <agpr-button
                class="agpr-targetingResults-listBuilder-addToListButton agpr-staffSearch-listBuilder-addToListButton"
                [id]="id + '.addToList'"
                [style]="buttonTypes.icon"
                icon="fa-regular fa-duotone fa-user-plus"
                [disabled]="!total || selectedResults.length === 0"
                (click)="addToList()"
                tooltip="Discover.listBuilder.widget.tooltip.addButton"
                tooltipPosition="left"
            ></agpr-button>
        </div>

        <!-- third row -->
        <div
            class="agpr-targetingResults-listBuilder-rhp-chipContainer"
            *ngIf="selectedListsChips?.length"
            [@toolbarCollapsed]="toolbarStateService.toolbarCollapsed && !toolbarStateService.toolbarAnimationDisabled"
            (@toolbarCollapsed.start)="onAnimationStart($event)"
            (@toolbarCollapsed.done)="onAnimationDone($event)"
        >
            <agpr-chip-container
                #listChipsComponent
                [id]="id + '.selectedLists.chips'"
                [chips]="selectedListsChips"
                (removeChip)="listPickerService.removeWorkingListByIndex($event)"
            ></agpr-chip-container>
            <agpr-button
                *ngIf="selectedLists.length > 1"
                class="agpr-targetingResults-toolbarIcon-clear"
                [style]="buttonTypes.link"
                id="listBuilderClear"
                (click)="clearListChips()"
                icon="agpr-i-clear"
                tooltip="Discover.listBuilder.widget.tooltip.clearAll"
                tooltipPosition="top"
            ></agpr-button>
        </div>

        <!-- bottom row -->
        <div
            class="agpr-staffSearch-selectBar agpr-staffSearch-selectBar-Container"
            [style.width]="toolbarStateService.toolbarCollapsed ? toolbarStateService.toolbarWidth + 'px' : '100%'"
        >
            <agpr-checkbox
                [id]="id + '_targetingResult_rhp_searchService_selectAll'"
                [binary]="true"
                hiddenLabel="selectAll"
                [disabled]="!total"
                [(ngModel)]="selectAllPage"
                (ngModelChange)="toggleSelectAllPage()"
            >
                <span class="agpr-staffSearch-selectBar-totalCount-value">
                    {{ selectAll ? total : (selectedResults?.length || '0') }}
                    <span class="agpr-staffSearch-selectBar-totalCount-text">
                        {{ 'Paginator.of' | localize }}
                        <span class="agpr-staffSearch-selectBar-totalCount-value">
                            {{ total || '0'}}
                        </span>
                        {{ 'Paginator.selected' | localize }}
                    </span>
                </span>
            </agpr-checkbox>
            <agpr-minimal-paginator [isDisabled]="!total"></agpr-minimal-paginator>
        </div>
        <div
            *ngIf="(selectedResults?.length >= numResults && total > selectedResults?.length)"
            class="agpr-staffSearch-selectAllNotice"
        >
            <agpr-message severity="info">
                <span *ngIf="!selectAll">
                    {{
                    'Discover.targeting.result.selectAll.notice.page' | localize : {
                        count: selectedResults.length
                        }
                    }}
                </span>
                <span *ngIf="selectAll">
                    {{
                    'Discover.targeting.result.selectAll.notice.all' | localize : {
                        count: total
                        }
                    }}
                </span>
                <agpr-button
                    *ngIf="!selectAll"
                    [label]="'Discover.targeting.result.selectAll.hyperlink.select' | localize : {
                        count: total
                    }"
                    (click)="selectAllResults()"
                    [style]="buttonTypes.link"
                    class="agpr-staffSearch-selectAllNotice-link"
                ></agpr-button>
                <agpr-button
                    *ngIf="selectAll"
                    [label]="'Discover.targeting.result.selectAll.hyperlink.clear' | localize"
                    (click)="selectNone()"
                    [style]="buttonTypes.link"
                    class="agpr-staffSearch-selectAllNotice-link"
                ></agpr-button>
            </agpr-message>
        </div>
    </ng-template>

    <div
        *ngIf="!chipsVisible"
        class="agpr-staffSearch-topScroll"
    >
        <!-- suggested contact -->
        <ng-container *ngIf="primaryContact && pageNumber === 1">
            <agpr-panel
                styleClass='agpr-staffSearch-panel'
                class='agpr-staffSearch-panel'
                [toggleable]="true"
                header="Discover.targeting.staffSearch.suggestedContact"
        >
                <div class="agpr-staffSearch-suggestedContact">
                    <agpr-staff-card
                        [id]="id + '_staffSearchTab_primaryContact'"
                        [disableSelection]="selectAll"
                        [entity]="primaryContact"
                        [selectedResults]="selectedResults"
                        (selectionChanged)="onCardSelect($event)"
                        (showRhpTakeOver)="showRhpTakeOver.emit($event)"
                    >
                    </agpr-staff-card>
                </div>
            </agpr-panel>
        </ng-container>
    </div>

    <agpr-panel
        *ngIf="results?.length > 0"
        styleClass='agpr-staffSearch-panel'
        class='agpr-staffSearch-panel'
        [toggleable]="true"
        [header]="!chipsVisible? 'Discover.targeting.staffSearch.allContacts':''"
>
        <ul
            [id]="id + '_staffList'"
            [attr.aria-label]="'Discover.targeting.staffSearch.allContacts' | localize"
            agprListKeyboardNavigation
            [focusOnChild]="true"
            [list]="results"
            focusableElementCustomSelector=".agpr-targetingResults-card"
        >
            <li *ngFor="let result of results; let i = index">
                <agpr-staff-card
                    [id]="id + '_staffSearchTab_' + i + '_staffCard'"
                    [disableSelection]="selectAll"
                    [entity]="result"
                    [selectedResults]="selectedResults"
                    (selectionChanged)="onCardSelect($event)"
                    (showRhpTakeOver)="showRhpTakeOver.emit($event)"
                ></agpr-staff-card>
            </li>
        </ul>
    </agpr-panel>
    @if ((!results || results.length === 0) && !primaryContact) {
        <agpr-message
            [severity]="messageSeverityEnum.noContent"
            [useWhiteBg]="true"
        >
            {{ 'Discover.targeting.result.noStaffFound' | localize }}
        </agpr-message>
    }
</div>
